import { createFileRoute, redirect, notFound, Link } from "@tanstack/react-router";
import { resolveLegacyRedirect } from "@/lib/legacyRedirects";

// Splat route: catches any URL not matched by an explicit route file.
// First checks the legacy-redirect map and 301s if found; otherwise throws a
// real not-found so the server responds with HTTP 404 (never a soft 404 that
// crawlers would try to index) and the page carries a `noindex` robots tag.
export const Route = createFileRoute("/$")({
  beforeLoad: ({ location }) => {
    const target = resolveLegacyRedirect(location.pathname);
    if (target) {
      throw redirect({ to: target, replace: true, statusCode: 301 });
    }
    throw notFound();
  },
  head: () => ({
    meta: [
      { title: "Page not found — Texas Made Shade & Covers" },
      { name: "robots", content: "noindex, follow" },
    ],
  }),
  component: NotFoundComponent,
  notFoundComponent: NotFoundComponent,
});

function NotFoundComponent() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-foreground">Page not found</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}
